import React from 'react'
import { Link } from 'react-router'

import TermsAndConditionsLink from '@/components/misc/TermsAndConditionsLink'
import { Container } from '@/components/ui/container'
import { useAuth } from '@/hooks/useAuth'
import { EMAIL_ADDRESSES } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'

const Footer: React.FC = () => {
  const { currentCompany, isClientUser, isIcaewUser } = useAuth()

  function getDisclaimerRoute(): string {
    if (isClientUser) {
      return ROUTES.compassDisclaimer()
    }

    return isIcaewUser ? ROUTES.icaewDisclaimer() : ROUTES.disclaimer()
  }

  return (
    <footer className="border-t bg-white p-3">
      <Container className="max-w-none">
        <div
          className="text-dim flex flex-col gap-2 sm:flex-row sm:flex-wrap
            sm:justify-between"
        >
          <ul
            className="mb-0 flex list-none flex-col gap-2 pl-0 sm:flex-row
              sm:gap-4"
          >
            <li>
              <Link className="text-dim" to={getDisclaimerRoute()}>
                RQ Certification disclaimer
              </Link>
            </li>

            <li>
              {currentCompany && (
                <TermsAndConditionsLink
                  label="Terms and conditions"
                  className="text-dim"
                />
              )}
            </li>

            <li>
              <a
                className="text-dim"
                href="https://www.rq.app/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                Privacy
              </a>
            </li>
          </ul>

          <div className="sm:text-right">
            <p className="mb-0">
              <a href={`mailto:${EMAIL_ADDRESSES.rqHello}`}>
                {EMAIL_ADDRESSES.rqHello}
              </a>
              <span className="mr-2 ml-2">+44(0)20 3856 4769</span>
              &copy; {new Date().getFullYear()} -{' '}
              <span className="text-dim">RQ Ratings Ltd.</span>
            </p>
          </div>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
